/**
 * Renders the Competition dropdown menu in the navigation bar on desktop
 * WARNING: Uses dummy data
 */
import React, { useEffect, useState } from "react";
import { CSSTransition } from "react-transition-group";
import ArrowIcon from "./ArrowIcon";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useDropdown } from "./DropdownContext";
import ClubLink from "./ClubLink";

const DropdownMenu = (id) => {
  const { openDropdown, setOpenDropdown } = useDropdown();
  const isOpen = openDropdown === id;

  const toggleDropdown = () => {
    setOpenDropdown(isOpen ? null : id);
  };

  const handleLinkClick = () => {
    setOpenDropdown(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        event.target.closest(".dropdown-menu") === null &&
        !event.target.closest(".relative")
      ) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setOpenDropdown]);

  const { isLoading, error, data } = useQuery({
    staleTime: Infinity,
    queryKey: ["division"],
    queryFn: () =>
      fetch(`${process.env.REACT_APP_BUIHA_API_URL}/division/`).then((res) =>
        res.json()
      ),
  });

  if (isLoading || error)
    return (
      <li className="relative group">
        <Link
          to="#"
          className="dark:hover:text-dark-5 hover:text-buiha-red hover:text-gray-800 py-2 px-4 lg:text-2xl text-xl md:flex hidden items-center font-medium"
          onClick={(e) => {
            e.preventDefault();
            toggleDropdown();
          }}
        >
          {" "}
          {/* Header */}
          Games
        </Link>
      </li>
    );

  // if (error) return 'An error has occurred: ' + error.message;

  data && data.sort((a, b) => (a.name > b.name ? 1 : -1));

  return (
    <li
      className="relative group"
      onMouseEnter={toggleDropdown}
      onMouseLeave={() => setOpenDropdown(null)}
    >
      {/*Temp link TODO replace*/}
      <Link
        to="#"
        className="dark:hover:text-dark-5 hover:text-buiha-red py-2 px-4 lg:text-2xl text-xl md:flex hidden items-center font-medium"
        onClick={(e) => {
          e.preventDefault();
          toggleDropdown();
        }}
      >
        {/* Header */}
        Games
        <ArrowIcon />
      </Link>

      {/* Dropdown menu */}
      <CSSTransition
        in={isOpen}
        timeout={200}
        classNames="dropdown"
        unmountOnExit
      >
        <div
            className={`dropdown-menu absolute bg-light-1 dark:bg-dark-4 border-2 border-light-3 dark: dark:border-dark-3 ml-3 pb-1 w-auto rounded-b-lg z-20`}
        >
          {/* Content */}

          <Link
              to="/gamecentre"
              className="w-full block px-2 pt-1 text-[1.15rem] hover-slide flex-row flex items-center"
              onClick={handleLinkClick}
          >
            <img src="/buihamini.png" alt="BUIHA Logo" className="w-6 h-6 mr-1"/>
            Gamecentre
          </Link>
          <div className="mx-2 border-t-2 border-light-6 dark:border-dark-6 w-88 my-1"></div>

          <div className="flex flex-row items-start">
            <div className="flex flex-col justify-center items-start">

              <div className="block w-56 pl-2 text-[1.15rem] flex flex-row ">

                <img src="/buihamini.png" alt="BUIHA Logo" className="w-6 h-6 mr-1"/>
                Cup Comp North
              </div>
              {data ? (
                  data.map((division) =>
                      // If club.status == active, then show the club
                      // division.status === "Active" &&
                      (division.conference === "North") ? (
                          <Link
                              to={"/division/" + division.id}
                              className="block w-56 px-2 text-[1.15rem] flex hover-slide"
                              handleLinkClick={handleLinkClick}
                          >{division.title}</Link>
                      ) : null
                  )
              ) : (
                  <></>
              )}
            </div>

            <div className="flex flex-col items-start">
              <div className="block w-56 pl-2 text-[1.15rem] flex flex-row">
                <img src="/buihamini.png" alt="BUIHA Logo" className="w-6 h-6 mr-1"/>
                Cup Comp South
              </div>
              {data ? (
                  data.map((division) =>
                      // If club.status == active, then show the club
                      // division.status === "Active" &&
                      (division.conference === "South") ? (
                          <Link
                              to={"/division/" + division.id}
                              className="block w-56 px-2 text-[1.15rem] flex hover-slide"
                              handleLinkClick={handleLinkClick}
                          >{division.title}</Link>
                      ) : null
                  )
              ) : (
                  <></>
              )}
            </div>
          </div>

          <div className="mx-2 border-t-2 border-light-6 dark:border-dark-6 w-88 my-1"></div>

          <div className="block w-112 pl-2 text-[1.15rem] flex flex-row ">

            <img src="/buihamini.png" alt="BUIHA Logo" className="w-6 h-6 mr-1"/>
            Checking Regional Play-Ins
          </div>

          <div className="flex flex-row items-start">
            <div className="flex flex-col justify-center items-start">


              {data ? (
                  data.map((division) =>
                      // If club.status == active, then show the club
                      // division.status === "Active" &&
                      division.conference === "Regionals North" ? (
                          <Link
                              to={"/division/" + division.id}
                              className="block w-56 px-2 text-[1.15rem] flex hover-slide"
                              handleLinkClick={handleLinkClick}
                          >{division.title}</Link>
                      ) : null
                  )
              ) : (
                  <></>
              )}
            </div>

            <div className="flex flex-col items-start">
              {data ? (
                  data.map((division) =>
                      // If club.status == active, then show the club
                      // division.status === "Active" &&
                      division.conference === "Regionals South" ? (
                          <Link
                              to={"/division/" + division.id}
                              className="block w-56 px-2 text-[1.15rem] flex hover-slide"
                              handleLinkClick={handleLinkClick}
                          >{division.title}</Link>
                      ) : null
                  )
              ) : (
                  <></>
              )}
            </div>
          </div>

          {/* Horizontal gray line */}
          <div className="mx-2 border-t-2 border-light-6 dark:border-dark-6 w-88 my-1"></div>
          <div className="flex flex-row items-start">

            <div className="block pl-2 text-[1.15rem] flex flex-row">
              <img src="https://buiha.org.uk/assets/img/icon/150/nationals.png" alt="BUIHA Logo"
                   className="w-6 h-6 mr-1"/>
              National Championships
            </div>
          </div>

          <div className="flex flex-row items-start">
            <div className="flex flex-col justify-center items-start">
              {data ? (
                  data.map((division) =>
                      // If club.status == active, then show the club
                      division.is_nationals === true && division.short !== "N-CHK" ? (
                          <Link
                              to={"/division/" + division.id}
                              className="block w-56 px-2 text-[1.15rem] flex hover-slide"
                              handleLinkClick={handleLinkClick}
                          >{division.title}</Link>
                      ) : null
                  )
              ) : (
                  <></>
              )}
            </div>

            <div className="flex flex-col items-start">
              {data ? (
                  data.map((division) =>
                      // If club.status == active, then show the club
                      division.is_nationals === true && division.short === "N-CHK" ? (
                          <Link
                              to={"/division/" + division.id}
                              className="block w-56 px-2 text-[1.15rem] flex hover-slide"
                              handleLinkClick={handleLinkClick}
                          >{division.title}</Link>
                      ) : null
                  )
              ) : (
                  <></>
              )}
            </div>
          </div>

        </div>
      </CSSTransition>
    </li>
  );
};

export default DropdownMenu;